import React from "react";
import { Row, Col, Card, Statistic, Spin, Progress } from "antd";
import {
  DashboardOutlined,
  ThunderboltOutlined,
  PauseCircleOutlined,
  CloseCircleOutlined,
  LogoutOutlined,
  ArrowUpOutlined,
  PlayCircleOutlined,
  ClockCircleOutlined,
  LineChartOutlined,
} from "@ant-design/icons";

const QoEOverviewCards = ({ data, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!data) return null;

  const formatTime = (ms) => {
    if (!ms) return "0ms";
    if (ms < 1000) return `${Math.round(ms)}ms`;
    return `${(ms / 1000).toFixed(1)}s`;
  };

  const formatWatchTime = (seconds) => {
    if (!seconds) return "0h";
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    if (hours > 0) return `${hours.toLocaleString()}h ${mins}m`;
    return `${mins}m`;
  };

  const cards = [
    {
      title: "Viewer Experience",
      value: data.viewerExperienceScore ? (data.viewerExperienceScore * 100).toFixed(1) : 0,
      suffix: "%",
      icon: <DashboardOutlined />,
      color: "#1890ff",
      gauge: data.viewerExperienceScore ? data.viewerExperienceScore * 100 : 0,
    },
    {
      title: "Startup Time",
      value: formatTime(data.videoStartupTimeMs),
      icon: <ThunderboltOutlined />,
      color: "#52c41a",
    },
    {
      title: "Rebuffer %",
      value: data.rebufferPercentage?.toFixed(2) || 0,
      suffix: "%",
      icon: <PauseCircleOutlined />,
      color: "#fa8c16",
    },
    {
      title: "Failure Rate",
      value: data.playbackFailureRate?.toFixed(2) || 0,
      suffix: "%",
      icon: <CloseCircleOutlined />,
      color: "#ff4d4f",
    },
    {
      title: "Exits Before Start",
      value: data.exitsBeforeVideoStart?.toFixed(2) || 0,
      suffix: "%",
      icon: <LogoutOutlined />,
      color: "#eb2f96",
    },
    {
      title: "Upscale %",
      value: data.upscalePercentage?.toFixed(1) || 0,
      suffix: "%",
      icon: <ArrowUpOutlined />,
      color: "#722ed1",
    },
    {
      title: "Total Views",
      value: data.totalViews?.toLocaleString() || 0,
      icon: <PlayCircleOutlined />,
      color: "#13c2c2",
    },
    {
      title: "Watch Time",
      value: formatWatchTime(data.totalWatchTimeSeconds),
      icon: <ClockCircleOutlined />,
      color: "#2f54eb",
    },
    {
      title: "Benchmark Score",
      value: data.globalBenchmarkScore ? (data.globalBenchmarkScore * 100).toFixed(1) : 0,
      suffix: "%",
      icon: <LineChartOutlined />,
      color: "#faad14",
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card) => (
        <Col xs={24} sm={12} md={8} key={card.title}>
          <Card bordered={false} style={{ borderTop: `3px solid ${card.color}` }}>
            <Statistic
              title={
                <span>
                  {React.cloneElement(card.icon, {
                    style: { color: card.color, marginRight: 8 },
                  })}
                  {card.title}
                </span>
              }
              value={card.value}
              suffix={card.suffix && <span style={{ fontSize: 14 }}>{card.suffix}</span>}
              valueStyle={{ fontSize: 22 }}
            />
            {card.gauge !== undefined && (
              <Progress
                percent={card.gauge}
                showInfo={false}
                strokeColor={card.gauge >= 80 ? "#52c41a" : card.gauge >= 50 ? "#fa8c16" : "#ff4d4f"}
                size="small"
                style={{ marginTop: 8 }}
              />
            )}
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default QoEOverviewCards;
